import React, { useState, useEffect } from 'react';
import LiquidGlass from 'liquid-glass-react';
import './App.css';
import BookmarkModal from './components/BookmarkModal'; // 稍后将创建此组件

function App() {
    const [modalState, setModalState] = useState({ isOpen: false, folder: null });
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        if (modalState.isOpen) {
            // 使用一个微小的延迟来确保组件已经挂载，然后再触发过渡效果
            const timer = setTimeout(() => {
                setIsModalVisible(true);
            }, 10);
            return () => clearTimeout(timer);
        }
    }, [modalState.isOpen]);

    // 处理"查看全部"按钮点击
    const handleViewAll = () => {
        alert('显示全部书签功能');
    };

    const handleFolderClick = (folder) => {
        setModalState({ isOpen: true, folder: folder });
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        // 等待动画完成后再将组件从 DOM 中移除
        setTimeout(() => {
            setModalState({ isOpen: false, folder: null });
        }, 300); // 这个时间应该与 CSS 中的 transition duration 匹配
    };

    const bookmarksData = [
        {
            type: 'folder',
            name: '常用网站',
            children: [
                { title: 'Google', url: 'https://google.com', favicon: 'https://www.google.com/favicon.ico' },
                { title: 'ChatGPT', url: 'https://chatgpt.com/', favicon: 'https://chatgpt.com/favicon.ico' },
            ]
        },
        { title: 'GitHub', url: 'https://github.com', favicon: 'https://www.github.com/favicon.ico' },
        { title: 'Stack Overflow', url: 'https://stackoverflow.com', favicon: 'https://cdn.sstatic.net/Sites/stackoverflow/Img/favicon.ico' },
        { title: 'Bing', url: 'https://www.bing.com', favicon: 'https://www.bing.com/favicon.ico' },
        { title: 'Apple Developer', url: 'https://developer.apple.com', favicon: 'https://developer.apple.com/favicon.ico' },
    ];

    return (
        <>
            <div className="container">
                <header>
                    <div className="logo"><div className="logo-icon"><i className="fas fa-bookmark"></i></div><div className="logo-text">个人书签</div></div>
                    <div className="header-actions">
                        <div className="user-actions">
                            <div className="btn btn-primary">
                                <LiquidGlass
                                    displacementScale={64}
                                    blurAmount={0.1}
                                    saturation={130}
                                    aberrationIntensity={2}
                                    elasticity={0.35}
                                    cornerRadius={10}
                                    padding="8px 16px"
                                    onClick={() => console.log('导入点击')}
                                    style={{
                                        position: "fixed",
                                        top: "8%",
                                        left: "83%",
                                    }}
                                >
                                    <span className="logout-content">
                                        导入
                                    </span>
                                </LiquidGlass>
                            </div>
                            <div className="btn btn-primary">
                                <LiquidGlass
                                    displacementScale={64}
                                    blurAmount={0.1}
                                    saturation={130}
                                    aberrationIntensity={2}
                                    elasticity={0.35}
                                    cornerRadius={10}
                                    padding="8px 16px"
                                    onClick={() => console.log('添加书签点击')}
                                    style={{
                                        position: "fixed",
                                        top: "8%",
                                        left: "89%",
                                    }}
                                >
                                    <span className="logout-content">
                                        添加书签
                                    </span>
                                </LiquidGlass>
                            </div>
                            <div className="logout-btn-container">
                                <LiquidGlass
                                    displacementScale={64}
                                    blurAmount={0.1}
                                    saturation={130}
                                    aberrationIntensity={2}
                                    elasticity={0.35}
                                    cornerRadius={10}
                                    padding="8px 16px"
                                    onClick={() => console.log('Log out clicked!')}
                                    style={{
                                        position: "fixed",
                                        top: "8%",
                                        left: "95%",
                                    }}
                                >
                                    <span className="logout-content">
                                        Log Out
                                    </span>
                                </LiquidGlass>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="bookmarks-section">
                    <div className="section-header">
                        <h1>个人收藏</h1>
                        <LiquidGlass
                            displacementScale={64}
                            blurAmount={0.1}
                            saturation={130}
                            aberrationIntensity={2}
                            elasticity={0.35}
                            cornerRadius={10}
                            padding="8px 16px"
                            onClick={handleViewAll}
                            style={{
                                position: "fixed",
                                top: "20%",
                                left: "90%",
                            }}
                        >
                            <span className="logout-content">
                                全部显示 <i className="fas fa-chevron-right"></i>
                            </span>
                        </LiquidGlass>
                    </div>

                    <div className="bookmarks-grid">
                        {bookmarksData.map((item, index) => (
                            <div className="bookmark-box" key={index}>
                                {item.type === 'folder' ? (
                                    <div className="bookmark-folder" onClick={() => handleFolderClick(item)}>
                                        <div className="favicon-container">
                                            <div className="folder-favicon-grid">
                                                {item.children.slice(0, 4).map((child, childIndex) => (
                                                    <img key={childIndex} src={child.favicon} alt="" className="folder-favicon-item" />
                                                ))}
                                            </div>
                                        </div>
                                        <span className="title">{item.name}</span>
                                    </div>
                                ) : (
                                    <a href={item.url} className="bookmark-link">
                                        <div className="favicon-container">
                                            <img src={item.favicon} alt={item.title} />
                                        </div>
                                        <span className="title">{item.title}</span>
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="reading-section">
                    <div className="section-header">
                        <h1>阅读列表</h1>
                        <LiquidGlass
                            displacementScale={64}
                            blurAmount={0.1}
                            saturation={130}
                            aberrationIntensity={2}
                            elasticity={0.35}
                            cornerRadius={10}
                            padding="8px 16px"
                            onClick={handleViewAll}
                            style={{
                                position: "fixed",
                                top: "55%",
                                left: "90%",
                            }}
                        >
                            <span className="logout-content">
                                全部显示 <i className="fas fa-chevron-right"></i>
                            </span>
                        </LiquidGlass>
                    </div>

                    <div className="reading-list">
                        <div className="reading-item">
                            <a href="https://developer.apple.com/documentation" className="reading-link">
                                <div className="favicon-container">
                                    <img src="https://developer.apple.com/favicon.ico" alt="Apple" />
                                </div>
                                <div className="content">
                                    <div className="title">Apple Developer Documentation</div>
                                </div>
                            </a>
                        </div>

                        <div className="reading-item">
                            <a href="https://www.speedtest.net" className="reading-link">
                                <div className="favicon-container">
                                    <img src="https://www.speedtest.net/favicon.ico" alt="Speedtest" />
                                </div>
                                <div className="content">
                                    <div className="title">网络速度测试</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <footer>
                    <p>© {new Date().getFullYear()} 个人收藏书签 | 已同步 128 个书签 | 最后更新: 今天 14:30</p>
                </footer>
            </div>

            {modalState.isOpen && (
                <BookmarkModal
                    folder={modalState.folder}
                    onClose={handleCloseModal}
                    isVisible={isModalVisible}
                />
            )}
        </>
    );
}

export default App;
